const REDUCER_ADVERT_CONTACTS_NAME = 'advertContacts';

export { REDUCER_ADVERT_CONTACTS_NAME };
